import "./IconAddress.scss";

export const IconAddress = () => {
  return <span className="icon-address"></span>;
};
